
import { createContext } from 'react'

export const customerContext = createContext(null)
